import { expVal } from '@atlassian/jira-feature-experiments';

const GlobalStatusesInTmpStatusFieldRelayProvider = {
	get(): boolean {
		return expVal('global_statuses_in_status_field_edit_status', 'isEnabled', false);
	},
};

export default GlobalStatusesInTmpStatusFieldRelayProvider;
